<template>
  <v-app :dark="isDark">
    <v-navigation-drawer
      fixed
      temporary
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      v-model="drawer"
    >
        <v-layout column fill-height>
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            row
            v-if="item.heading"
            align-center
            :key="item.heading"
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading|translate}}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-show="item.children.length>0"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item['icon-alt']"
            append-icon="item['icon-alt']"
          >

            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text|translate}}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              @click="jumpToLink(child.to)"
              style="text-indent:30px"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text|translate}}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else-if="item.href" @click="openInternalHref(item.href)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text|translate}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else @click="jumpToLink(item.to)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text|translate}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
            <v-spacer></v-spacer>
            <div style="height:50px;">
                <img class="ml-3" :src="require('@/assets/img/carnotLogo.png')" height="27"/>
                <span class="ml-4" style="padding-top: 0">
            powered by <strong>Carnot Innovations</strong>
        </span>
            </div>
        </v-layout>
    </v-navigation-drawer>
    <v-toolbar
      color="primary darken-1 hidden-print-only"
      v-if="!hideToolbar"
      dark
      dense
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
    >
      <v-toolbar-title v-if="!disableMenu" :style="brandName=='JEC'||brandName=='Carnot Innovations' ? 'width: 80px' :'width: 600px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span v-if="brandName!='JEC'&&brandName!='Carnot Innovations'" class="hidden-sm-and-down">{{brandName}} - {{facilityName=='AX' ? 'AH' : facilityName}} </span>
      </v-toolbar-title>
      <img v-if="brandName=='JEC'" @click="jumpToLink('/')" class="cursor-as-pointer" :src="require('@/assets/img/logojec.jpg')" height="48"/>
      <span v-if="brandName=='JEC'" @click="jumpToLink('/')" class="hidden-sm-and-down cursor-as-pointer" style="padding-top: 28px;">
            - {{facilityName=='AX' ? 'AH' : facilityName}}
        </span>
      <img v-if="brandName=='Carnot Innovations'" @click="jumpToLink('/')" class="cursor-as-pointer" :src="require('@/assets/img/carnotLogo.png')" height="40"/>
      <span v-if="brandName=='Carnot Innovations'" @click="jumpToLink('/')" class="hidden-sm-and-down cursor-as-pointer" style="padding-top: 0">
            Carnot Innovations <span v-if="!demoOverride">- {{facilityName=='AX' ? 'AH' : facilityName}}</span>
        </span>
      <v-spacer></v-spacer>
      <v-menu offset-y class="mr-1" v-if="langSelect">
        <v-btn flat large slot="activator">
          <v-icon class="mr-2">fa-globe</v-icon> {{langMap[currentLang]}}
        </v-btn>

        <v-list>

          <v-list-tile v-for="lang in languages" v-if="lang.value!==currentLang" @click.prevent="setLang(lang.value)">
            <v-list-tile-title> {{lang.text}} </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="jumpToLink('/')" v-bind="attrs" v-on="on">
            <v-icon>fa-th</v-icon>
          </v-btn>
        </template>
        <span>Overview</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" >
            <v-badge v-if="!disableNotifications"
              color="accent"
              overlap
            >
              <template v-slot:badge>
                <span>{{notificationCount}}</span>
              </template>
            <v-icon @click="jumpToLink('/notifications')" >fa-bell</v-icon>
            </v-badge>
          </div>
        </template>
        <span>Notifications</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!disableNotifications" icon to="/maintenancerecord" v-bind="attrs" v-on="on">
            <v-icon>fa-notes-medical</v-icon>
          </v-btn>
        </template>
        <span>Maintenance Record</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-menu offset-y>
            <v-btn icon large slot="activator" v-bind="attrs" v-on="on">
              <v-avatar size="32px" tile>
                <v-icon>fa-user</v-icon>
              </v-avatar>
            </v-btn>          
            <v-list>
              <v-list-tile><v-list-tile-title>{{'Logged in as'|translate}} {{username}}</v-list-tile-title></v-list-tile>
              <v-list-tile @click="userdialog=true" v-if="!authIsExternal">
                <v-list-tile-title> {{'Account Settings'|translate}} </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.prevent="logout">
                <v-list-tile-title> {{'Logout'|translate}} </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>
        <span>User Account</span>
      </v-tooltip>
      <user-profile-dialog v-model="userdialog" :item="username" ></user-profile-dialog>
    </v-toolbar>

    <v-content>
      <transition enter-active-class="animated fadeIn"
                  leave-active-class="animated flipOutY"
                  appear
                  mode="out-in">
      <v-container key="1" fluid fill-height v-if="$store.state.pointsListStore.pointsLoaded||forceDisplay" id="carnotMainContent">
        <v-layout justify-center align-start>
          <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-layout>
      </v-container>
      <v-container key="2" fluid fill-height v-else>
        <v-layout justify-center align-center>
          {{'Loading Points List'|translate}} <v-progress-circular class="ml-3" color="primary" indeterminate></v-progress-circular>
        </v-layout>
      </v-container>
      </transition>


    </v-content>
<!--    <v-toolbar v-if="hideToolbar">-->
<!--      <v-btn outline class="secondary" to="/notifications">{{'Notification'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/modelsummary">{{'Machine Learning Fault Detection'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/controllogic">{{'Control Logic Benefit'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/multiplots">{{'Time Series Plot'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/maintenancerecord">{{'Maintenance Record'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/energyefficiency">{{'COP'|translate}}</v-btn>-->
<!--      <v-btn outline class="secondary" to="/load">{{'Cooling Load'|translate}}</v-btn>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-btn flat @click="drawer=!drawer">   </v-btn>-->
<!--    </v-toolbar>-->

    <global-snackbar></global-snackbar>

  </v-app>
</template>


<script>

import GlobalSnackbar from './components/GlobalSnackbar'
import UserProfileDialog from "./components/users/UserProfileDialog";
import { jwtDecode,getCurrentUser} from './helper'
import { mapGetters } from 'vuex'
import { msalMixin } from "vue-msal";
export default {
  name: 'App',
  mixins: [msalMixin],
  components: { GlobalSnackbar,UserProfileDialog},
  data: () => ({
    openfault: true,
    langSelect:false,
    currentLang:"en",
    languages:[],
    langMap:{},
    forceDisplay:false,
      dialog: false,
      userdialog: false,
      drawer: false,

    }),
    props: {
    },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    setLang(lang){
      this.currentLang=lang
      localStorage.setItem('currentLang', lang)
      setTimeout(function (){window.location.reload()},500)
    },
    jumpToLink (payload) {
      if(payload==="/"&&this.items&&this.items[0]&&this.items[0].text==="Overview"&&this.items[0].to!=="/overview"){
        this.$router.push(this.items[0].to)
      } else {
        this.$router.push(payload)
      }
    },
    openInternalHref(href){
      let pass = localStorage.getItem('pass');
      window.location.href=href+'?token='+pass;
    },
    logout () {
      if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
        this.$msal.signOut()
      } else {
        localStorage.setItem('pass', '') //reset token in localstorage
        window.location.href="/login";
      }
    },
    sendToLogin(){
      this.$router.push({
        name: 'login',
        query: {
          wantedRoute: this.$router.currentRoute.fullPath
        },
      });
      this.forceDisplay=true;
    },
    async initCore(){
      await this.$store.dispatch('refreshFacilityList')
      await this.$store.dispatch('refreshPointsList', null)
      await this.$store.dispatch('refreshUserPlots')
      await this.$store.dispatch('refreshPublishedCustomViews')
      if(!this.disableNotifications){
        await this.$store.dispatch('refreshNotification',
                {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'ignore_acknowledged': true
                })
      }
      if(this.$router.currentRoute.path==="/"&&this.items&&this.items[0]&&this.items[0].text==="Overview"&&this.items[0].to!=="/overview"){
        await this.$router.push(this.items[0].to)
      }
    },
  },
  watch: {
    '$route.name': {
      handler: function(item) {
        if(item==="login"){
          this.forceDisplay=true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'automatedViewsConfig','userPlots','publishedCustomViews','hiddenMenuItems',
    ]),
    brandName(){
      if (localStorage.getItem('brandingOverride')=== '1'){
        return "Carnot Innovations"
      }
      return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
    },
      demoOverride(){
        return localStorage.getItem('brandingOverride')=== '1'
      },
    disableMenu(){
      return process.env.VUE_APP_DISABLE_MENU ? process.env.VUE_APP_DISABLE_MENU : false
    },
    disableNotifications(){
      return process.env.VUE_APP_DISABLE_NOTIFICATIONS ? process.env.VUE_APP_DISABLE_NOTIFICATIONS : false
    },
    isDark(){
      return process.env.VUE_APP_THEME=='dark'
    },
    facilityName(){
      return this.$store.state.pointsListStore.pointsList.facility_name;
    },
    hideToolbar () {
      return process.env.VUE_APP_HIDE_TOOLBAR=='yes'
    },
    username () {
      if (this.$store.state.userStore.user) {
        return this.$store.state.userStore.user.content.user_name
      }
      return null;
    },
    notificationCount () {
      return this.$store.getters.importantNotificationsCount
    },
    authIsExternal () {
      return process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH!==""
    },
    items () {
      return _.filter(this.rawItems, (x) => {
        return !(_.get(x, 'disabled', false))
      })
    },
    rawItems () {
      let allItems=[]
      if(process.env.VUE_APP_MENU_CONFIG&&process.env.VUE_APP_MENU_CONFIG!==""){
        allItems=require('./config/menu/'+process.env.VUE_APP_MENU_CONFIG+".js").default()
      } else {
        allItems = [
          {icon: 'fa-address-book', text: 'Overview', to: '/overview'},
          {
            icon: 'fa-chart-bar',
            text: 'Detailed Overview',
            to: '/detailed-overview',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {
            icon: 'fa-bolt',
            text: 'Energy',
            to: '/energy',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {
            icon: 'fa-piggy-bank',
            text: 'Key Savings Metrics',
            to: '/key-savings',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },

          {
            icon: 'fa-chart-bar',
            text: 'KPI',
            to: '/kpi-view',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {
            icon: 'fa-bell',
            text: 'Notification Breakdown',
            to: '/notification-breakdown',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },

          {
            icon: 'fa-calendar-alt',
            text: 'Monthly Summary',
            to: '/mtr-monthly-summary',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },
          {icon: 'fa-bolt', text: 'Power Consumption', to: '/power-consumption', disabled: this.facilityName != 'SHT'},
          {
            icon: 'fa-bolt',
            text: 'Energy Consumption trend',
            to: '/energy-trend',
            disabled: this.facilityName == 'ES' || this.facilityName == 'AZBIL'
          }, //no point in showing since ES overview is literally this
          {icon: 'fa-chart-pie', text: 'Circuits', to: '/circuits', disabled: this.facilityName != 'SHT'},
          {icon: 'fa-thermometer-half', text: 'Graphical', to: '/graphical', disabled: this.facilityName != 'CRP'},
          {icon: 'fa-history', text: 'Cooling Load', to: '/load', disabled: this.facilityName == 'AZBIL'},

          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Plots',
            model: false,
            children: [
              {icon: 'fa-chart-bar', text: 'Simple Plots', to: '/sensors'},
              {icon: 'fa-chart-line', text: 'Time Series Plots', to: '/multiplots'},
              {icon: 'fa-chart-line', text: 'Equipment Plots', to: '/equipment-plots'},
              {icon: 'fa-layer-group', text: 'Facet Plots', to: '/plot/facet'},
            ]
          },


          {icon: 'fa-bell', text: 'Fault Detection', to: '/fault'},
          {icon: 'fa-bell', text: 'Fault Detection (Machine Learning)', to: '/modelsummary'},
          {
            icon: 'fa-bell',
            text: 'Fault Summary',
            to: '/faults-report',
            disabled: this.facilityName != 'SHT' && this.facilityName != 'CRP'
          },

          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Diagnostics',
            model: false,
            disabled: this.$store.getters.chillerType != 'generic water-cooled' && this.facilityName != 'SHT' || this.facilityName == 'AZBIL',
            children: this.facilityName == 'SHT' ? [
              {text: 'Number of Observations', to: '/observations'},
            ] : this.facilityName == 'ES' ? [{text: 'Cooling Load VS Outdoor Temperature', to: '/cl-vs-oat'},
              {text: 'Chiller Sequencing Profile - % of FLA', to: '/chiller-sequencing-fla'},
              {text: 'Chiller Sequencing Profile - DTchw', to: '/chiller-sequencing-delta'}] : []
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Control Logic',
            model: false,
            disabled: this.facilityName == 'ES' || this.facilityName == 'AZBIL',
            children: [
              {icon: 'fa-bolt', text: 'Energy Efficiency', to: '/energyefficiency'},
              {icon: 'fa-calculator', text: 'COP Calculator', to: '/refrigerantcalculate'},
              {icon: 'fa-thermometer-half', text: 'Control Logic Benefit', to: '/controllogic'},
              {icon: 'fa-magic', text: 'Dynamic Control Output', to: '/controloutput'},
            ]
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Control Logic',
            model: false,
            disabled: this.facilityName != 'ES',
            children: [
              {icon: 'fa-bolt', text: 'Energy Efficiency', to: '/energyefficiency'},
              // { icon: 'fa-calculator', text: 'COP Calculator', to: '/refrigerantcalculate'},
              // { icon: 'fa-thermometer-half', text: 'Control Logic Benefit', to:'/controllogic' },
            ]
          },
          {
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'Config',
            model: false,
            children: [
              {icon: 'fa-tools', text: 'Equipments', to: '/equipments'},
              {icon: 'fa-building', text: 'Facilities', to: '/facility'},
              {icon: 'fa-bell', text: 'Anomaly Descriptions', to: '/anomaly-description'},
              {icon: 'fa-broadcast-tower', text: 'Points', to: '/points'},
              {icon: 'fa-cog', text: 'Config', to: '/config'},
              {icon: 'fa-ruler-horizontal', text: 'Parameter', to: '/parameter'},
              {icon: 'fa-sliders-h', text: 'Settings', to: '/settings'},
              {icon: 'fa-mail-bulk', text: 'Report', to: '/report'},
              {icon: 'fa-align-justify', text: 'Rules', to: '/rules'},
              {icon: 'fa-users', text: 'Users', to: '/users'},
              {icon: 'fa-download', text: 'Export Data', to: '/viewdata'}
            ]
          },

          {icon: 'fa-notes-medical', text: 'Maintenance Record', to: '/maintenancerecord'},
          {icon: 'fa-question', text: 'Help', to: '/help'}
        ];
      }
      for(let id in this.automatedViewsConfig){
        let itemEntry={
          icon: this.automatedViewsConfig[id].icon,
          text: this.automatedViewsConfig[id].linkTitle,
          facilityFilter:this.automatedViewsConfig[id].facilityFilter ? this.automatedViewsConfig[id].facilityFilter : null,
          to:'/automated/'+id
        };
        if(this.automatedViewsConfig[id].menu){
          let found=false;
          for (let item of allItems){
            if(item.children&&item.text===this.automatedViewsConfig[id].menu){
              item.children.push(itemEntry);
              found=true;
              break;
            }
          }
          if(!found){
            allItems.push({
              icon: 'fa-angle-up',
              'icon-alt': 'fa-angle-down',
              text: this.automatedViewsConfig[id].menu,
              model: false,
              children: [itemEntry]
            });
          }
        } else if (!this.automatedViewsConfig[id].hidden) {
          allItems.push(itemEntry);
        }

      }
      if (this.hiddenMenuItems&&this.hiddenMenuItems!==""){
        let splitItems=this.hiddenMenuItems.split(",")
        allItems=allItems.filter(x=>!splitItems.includes(x.to))
        for (let item of allItems){
          if(item.children&&item.children.length>0){
            item.children=item.children.filter(x=>!splitItems.includes(x.to))
          }
        }
      }
      let me=this
      if (this.publishedCustomViews) {
        let filtered = this.publishedCustomViews.filter(x => x.facility === me.$store.state.pointsListStore.pointsList.facility_name)
        for (let userPlot of filtered) {
          let itemEntry = {'text': userPlot.linkTitle, 'to': "/custom-view/" + userPlot.id};
          if(userPlot.icon){
            itemEntry.icon=userPlot.icon
          }
          if (userPlot.isRootItem) {
            if(userPlot.itemOrder||userPlot.itemOrder===0){
              allItems.splice(userPlot.itemOrder,0,itemEntry)
            } else {
              allItems.push(itemEntry)
            }
          } else {
            let menuName = userPlot.menu ? userPlot.menu : 'Custom Views'
            let found = false;
            for (let item of allItems) {
              if (item.children && item.text === menuName) {
                if(userPlot.itemOrder||userPlot.itemOrder===0){
                  item.children.splice(userPlot.itemOrder,0,itemEntry)
                } else {
                  item.children.push(itemEntry)
                }
                found = true;
                break;
              }
            }
            if (!found) {
              allItems.push({
                icon: 'fa-angle-up',
                'icon-alt': 'fa-angle-down',
                text: menuName,
                model: false,
                children: [itemEntry]
              });
            }
          }

        }
      }
      if(this.$store.state.userStore.user&&this.userPlots){
        let filtered=this.userPlots.filter(x=>x.facility===me.$store.state.pointsListStore.pointsList.facility_name&&x.user_id===me.$store.state.userStore.user.content.sub)
        if(filtered.length>0){
          allItems.push({
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'User',
            model: false,
            children: filtered.map(function(userPlot){
              return {'text':userPlot.linkTitle,'to':"/user-automated/"+userPlot.id}
            })
          });
        }

      }
      for (let item of allItems){
        if(item.facilityFilter&&item.facilityFilter!==""&&item.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        } else if (item.facilityExceptFilter&&item.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        }
        if(item.children){
          for (let child of item.children){
            if(child.facilityFilter&&child.facilityFilter!==""&&child.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            } else if(child.facilityExceptFilter&&child.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            }
          }
          item.children=item.children.filter(x=>!x.toRemove)
        }
      }
      return allItems;
    }

  },
  async mounted () {
    if(process.env.VUE_APP_PAGE_TITLE&&process.env.VUE_APP_PAGE_TITLE!=""&&!this.demoOverride){
      document.title=process.env.VUE_APP_PAGE_TITLE
    } else {
      document.title="Carnot Innovations Dashboard"
    }
    if(process.env.VUE_APP_INTERFACE_TRANSLATION){
      let translator = require('./translator.js').default
      this.currentLang=translator.currentLang
      this.languages=translator.languages
      let newLangMap={}
      for(let lang of translator.languages){
        newLangMap[lang.value]=lang.text
      }
      this.langMap=newLangMap
      this.langSelect=true
    }

    if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
      await this.sleep(600)
      if (this.$msal.isAuthenticated()) {
        await this.sleep(600)
        let token= await this.$msal.acquireToken()
        await this.sleep(100)
        if(!token||!token.accessToken){
          console.log("azure auth anomaly")
          if (this.$router.currentRoute.name === "login") {
            this.forceDisplay = true;
          } else {
            this.sendToLogin()
          }
        } else {
          let cuRec=await getCurrentUser()
          await this.$store.dispatch('setUser', {token: token, content: cuRec.user})
          await this.initCore()
        }
      } else if (this.$router.currentRoute.name === "login") {
        this.forceDisplay = true;
      } else {
        this.sendToLogin()
      }
    } else {
      let token = localStorage.getItem('pass')
        if(!token&&process.env.VUE_APP_OVERRIDE_TOKEN){
            token=process.env.VUE_APP_OVERRIDE_TOKEN
        }
      if(token&&token!==""){
        let content=null;
        try {
          content = jwtDecode(token)
        }
        catch(err) {
          localStorage.setItem('pass', null)
          this.sendToLogin()
        }
        if(content){
          await this.$store.dispatch('setUser', {token: token, content: content})
          await this.initCore()
        }
      } else if (process.env.VUE_APP_LOGIN!='yes') {
        await this.initCore()
      } else if(this.$router.currentRoute.name=="login"){
        this.forceDisplay=true;
      } else {
        this.sendToLogin()
      }
    }


  }
}

</script>

<style scoped>
 .slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>

<style>
  .cursor-as-pointer{
    cursor: pointer;
  }
  .v-input__control>.v-input__slot input {
    caret-color: auto;
  }
  .v-input__control>.v-input__slot textarea {
    caret-color: auto;
  }
  .v-card__title{
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .v-card__title .v-input{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .v-card__title button{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  div>label.primary--text {
    color:#9b9b9b !important;
  }

  i.fa-times-circle {
    color:#9b9b9b !important;
  }

  a.v-list__tile--active{
    color:#9b9b9b !important;
  }

  .v-dialog {
    background-color:#424242;
  }

</style>
